import { Injectable } from "@angular/core";
import { IntegratedAdmissionWizardService } from "./integrated-admission-wizard.service";
import { IntegratedAdmissionAppointment } from "src/app/model/integrated-admission/integrated-admission-appointment";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { IntegratedAdmissionService } from "src/app/services/integrated-admission/integrated-admission.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { OnLineValidationService } from "src/app/services/on-line-validation/on-line-validation.service";
import { PracticeService } from "src/app/services/practice.service";
import { ValorizationService } from "src/app/services/valorization/valorization.service";
import { IntegratedAdmissionAppointmentPlan } from "src/app/model/integrated-admission/integrated-admission-appointment-plan";
import { InvoicePatientCashDeskService } from "src/app/services/invoice-cash-desk/invoice-patient-cash-desk.service";
import { InvoiceIntegratedAdmissionCashDeskService } from "src/app/services/invoice-cash-desk/invoice-integrated-admission-cash-desk.service";
import { InvoiceCashDeskService } from "src/app/services/invoice-cash-desk/invoice-cash-desk.service";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { BudgetService } from "src/app/services/budget/budget.service";
import { MatDialog } from "@angular/material";
import { Observable } from "rxjs";
import { NormativeService } from "src/app/services/normative/normative.service";
import { ReservationService } from "src/app/services/reservation.service";
import { AdmissionGroupedProcedureRegionService } from "src/app/services/admission-grouped-procedure-region/admission-grouped-procedure-region.service";
import { PatientService } from "src/app/services/patient.service";
import { LaboratoryAppointmentQuestionService } from "src/app/services/laboratory-appointment-question/laboratory-appointment-question.service";
import { CampaniaEncuestaService } from "src/app/services/campania-encuesta/campania-encuesta.service";
import { TurnoCampaniaEncuestaRespuestaService } from "src/app/services/campania-encuesta/turno-campania-encuesta-respuesta.service";
import { ServerTimeService } from "src/app/services/server-time.service";

@Injectable({
  providedIn: "root",
})
export class IntegratedAdmissionPreWizardService extends IntegratedAdmissionWizardService {
  constructor(
    public authService: AuthService,
    public patientService: PatientService,
    public router: Router,
    public notificationToastService: NotificationToastService,
    public onLineValidationService: OnLineValidationService,
    public integratedAdmissionService: IntegratedAdmissionService,
    public valorizationService: ValorizationService,
    public practiceService: PracticeService,
    public invoiceIntegratedAdmissionCashDeskService: InvoiceCashDeskService,
    public confirmDialogService: ConfirmDialogService,
    public budgetService: BudgetService,
    public campaniaEncuestaService: CampaniaEncuestaService,
    public turnoCampaniaEncuestaRespuestaService: TurnoCampaniaEncuestaRespuestaService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    public normativeService: NormativeService,
    public reservationService: ReservationService,
    public laboratoryAppointmentQuestionService: LaboratoryAppointmentQuestionService,
    public admissionGroupedProcedureRegionService: AdmissionGroupedProcedureRegionService,
    public serverTimeService: ServerTimeService
  ) {
    super(
      authService,
      patientService,
      router,
      notificationToastService,
      onLineValidationService,
      integratedAdmissionService,
      valorizationService,
      practiceService,
      invoiceIntegratedAdmissionCashDeskService,
      confirmDialogService,
      budgetService,
      campaniaEncuestaService,
      turnoCampaniaEncuestaRespuestaService,
      dialog,
      normativeService,
      reservationService,
      laboratoryAppointmentQuestionService,
      admissionGroupedProcedureRegionService,
      serverTimeService
    );
  }

  getConfirmDialog(): Observable<boolean> {
    return this.confirmDialogService.confirm(
      "Admisión",
      "¿Esta seguro que desea finalizar la admisión?",
      "Finalizar",
      "Cancelar",
      false,
      true,
      true
    );
  }

   validateProceduresForValidationLoaded(): boolean {
    return true;
  }

  showPreAdmissionPatientAppointment(): boolean {
    return false;
  }

  linkAppointmentWait(): boolean {
    return true;
  }

  showAddAppointment(): boolean {
    return true;
  }

  showCopyAppointment(): boolean {
    return true;
  }

  showPrint(): boolean {
    return false;
  }

  async finish() {
    await this.create();
  }

  cancel(): void {
    if (this.existsValidateedAppointmet()) {
      this.notificationToastService.info(
        "EXISTEN PRÁCTICAS REGISTRADAS QUE NO TIENEN VALIDACIÓN, ANULE ANTES DE SALIR",
        "Admisión"
      );
    } else {
      const appointmentId = +this.activatedRoute.snapshot.paramMap.get(
        "MedicalAppointmentId"
      );
      if (appointmentId) {
        this.router.navigate(["reservation-search"]);
      } else {
        window.location.reload();
      }
    }
  }

  getReturnUrl(): string {
    return "integrated-pre-admission";
  }

  async getNewPreAdmission(): Promise<IntegratedAdmissionAppointment> {
    const appointment = await this.integratedAdmissionService.getNewAdmission(
      this.sectorId,
      true
    );

    appointment.Plan = new IntegratedAdmissionAppointmentPlan();
    appointment.IsPre = true;


    console.log(appointment);

    return appointment;
  }

  canExtractProcedures(): boolean {
    return true;
  }

  canRefreshPracticeToParticular(): boolean {
    return false;
  }

  async getInitAdmission(): Promise<IntegratedAdmissionAppointment[]> {
    const appointmentId = +this.activatedRoute.snapshot.paramMap.get(
      "MedicalAppointmentId"
    );
    const patientId = +this.activatedRoute.snapshot.paramMap.get("PatientId");

    if (appointmentId && patientId) {
      let budgetId;

      const appointments =
        await this.integratedAdmissionService.getNewRegularAdmission(
          this.sectorId,
          appointmentId,
          budgetId
        );

      appointments.forEach((appointment) => {
        appointment.BudgetId = budgetId;
        appointment.IsPre = true;
        appointment.IsExtraordinary = true;
        this.patientId = appointment.PatientId;
      });

      return appointments;
    }



    return [await this.getNewPreAdmission()];
  }
  async getNewAdmission(): Promise<IntegratedAdmissionAppointment> {
    return await this.getNewPreAdmission();
  }

  isIntegradaPrevia(): boolean { return true; }
  isIntegradaSinTurno(): boolean { return false; }
  isIntegradaConTurno(): boolean { return false; }
}
